export const CATEGORY_AUTHORING_CONTENT = "Authoring & Content"
export const CATEGORY_COST_MODELLER = "Cost Modeller"
export const CATEGORY_PLANNING_COMPLIANCE = "Planning & Compliance"
export const CATEGORY_MAINTENANCE_REGIMES = "Maintenance Regimes"
export const CATEGORY_SCHEDULE_LIBRARY = "Schedule Library & Exports"
export const CATEGORY_ASSETS_MAPPING = "Asset Registers & Mapping"
export const CATEGORY_IDENTITY_ACCESS = "Identity & Access"
export const CATEGORY_SHARING_API = "Sharing & API"
export const CATEGORY_PLATFORM_ADMIN = "Client & Platform Administration"
export const CATEGORY_ACCESSIBILITY_UI = "Accessibility & UI"
export const CATEGORY_QA_TESTING = "QA & Test Tools"

export const DEFAULT_CATEGORY = CATEGORY_PLATFORM_ADMIN

export const CATEGORIES = [
    CATEGORY_AUTHORING_CONTENT,
    CATEGORY_COST_MODELLER,
    CATEGORY_PLANNING_COMPLIANCE,
    CATEGORY_MAINTENANCE_REGIMES,
    CATEGORY_SCHEDULE_LIBRARY,
    CATEGORY_ASSETS_MAPPING,
    CATEGORY_IDENTITY_ACCESS,
    CATEGORY_SHARING_API,
    CATEGORY_PLATFORM_ADMIN,
    CATEGORY_ACCESSIBILITY_UI,
    CATEGORY_QA_TESTING,
]

export const FEATURE_CATEGORY = {
    "52WeekPlanner": CATEGORY_PLANNING_COMPLIANCE,
    "Advanced-API": CATEGORY_SHARING_API,
    adoptClient: CATEGORY_PLATFORM_ADMIN,
    "ai-schedules": CATEGORY_SCHEDULE_LIBRARY,
    "api-expose-zerou": CATEGORY_SHARING_API,
    "api-use-unique-code": CATEGORY_SHARING_API,
    "applicationSwitcher-all-users": CATEGORY_PLATFORM_ADMIN,
    "asset-mapping-overview": CATEGORY_MAINTENANCE_REGIMES,
    "asset-mapping-refresh-all-mappings": CATEGORY_ASSETS_MAPPING,
    "asset-mapping-schedule-library-updates": CATEGORY_MAINTENANCE_REGIMES,
    "asset-mapping-tailored": CATEGORY_MAINTENANCE_REGIMES,
    "asset-mapping-variation-from-library": CATEGORY_MAINTENANCE_REGIMES,
    assets: CATEGORY_ASSETS_MAPPING,
    authoring: CATEGORY_AUTHORING_CONTENT,
    "authoring-amends-summary": CATEGORY_AUTHORING_CONTENT,
    "authoring-new-schedules": CATEGORY_AUTHORING_CONTENT,
    calendarView: CATEGORY_PLANNING_COMPLIANCE,
    "check-list": CATEGORY_SCHEDULE_LIBRARY,
    "client-statistics-all-users": CATEGORY_PLATFORM_ADMIN,
    clientBackup: CATEGORY_PLATFORM_ADMIN,
    codesOfPractice: CATEGORY_PLANNING_COMPLIANCE,
    companionTasks: CATEGORY_SHARING_API,
    "component-macros": CATEGORY_AUTHORING_CONTENT,
    configureWeekdays: CATEGORY_PLANNING_COMPLIANCE,
    "content-translation": CATEGORY_AUTHORING_CONTENT,
    "download-booklet": CATEGORY_SCHEDULE_LIBRARY,
    "download-tasks": CATEGORY_SCHEDULE_LIBRARY,
    "download-xml": CATEGORY_SCHEDULE_LIBRARY,
    downloadSchedulePdf: CATEGORY_SCHEDULE_LIBRARY,
    "edit-assets": CATEGORY_ASSETS_MAPPING,
    gridView: CATEGORY_PLANNING_COMPLIANCE,
    "legislation-library": CATEGORY_AUTHORING_CONTENT,
    legislationResolutions: CATEGORY_AUTHORING_CONTENT,
    "maintenance-reference-documents": CATEGORY_AUTHORING_CONTENT,
    mobiliser: CATEGORY_ASSETS_MAPPING,
    "mock-idp": CATEGORY_QA_TESTING,
    moveSchedules: CATEGORY_PLATFORM_ADMIN,
    navigator: CATEGORY_ASSETS_MAPPING,
    plan: CATEGORY_PLANNING_COMPLIANCE,
    preferUniqueCodes: CATEGORY_SCHEDULE_LIBRARY,
    "project-bridge": CATEGORY_AUTHORING_CONTENT,
    "promote-scenario-regime": CATEGORY_COST_MODELLER,
    "qrCodes-pdf": CATEGORY_SCHEDULE_LIBRARY,
    "regime-auditing": CATEGORY_MAINTENANCE_REGIMES,
    "regime-draft-locking": CATEGORY_MAINTENANCE_REGIMES,
    "regime-schedule-history": CATEGORY_MAINTENANCE_REGIMES,
    regimePermissions: CATEGORY_MAINTENANCE_REGIMES,
    "review-projects": CATEGORY_AUTHORING_CONTENT,
    "scenario-planner": CATEGORY_COST_MODELLER,
    "scenario-planner-conditional-trades": CATEGORY_COST_MODELLER,
    "sessionmanager-all-users": CATEGORY_PLATFORM_ADMIN,
    "side-nav-redesign": CATEGORY_ACCESSIBILITY_UI,
    "sso-all-users": CATEGORY_IDENTITY_ACCESS,
    "sso-client-config": CATEGORY_IDENTITY_ACCESS,
    "tailored-schedule-auditing": CATEGORY_MAINTENANCE_REGIMES,
    "testing-tools": CATEGORY_QA_TESTING,
    weekView: CATEGORY_PLANNING_COMPLIANCE,
}

export const NUMERICAL_ROOT = {
    1: CATEGORY_PLATFORM_ADMIN,
    2: CATEGORY_ASSETS_MAPPING,
    3: CATEGORY_SCHEDULE_LIBRARY,
    4: CATEGORY_PLATFORM_ADMIN,
    5: CATEGORY_PLANNING_COMPLIANCE,
    6: CATEGORY_SCHEDULE_LIBRARY,
    7: CATEGORY_MAINTENANCE_REGIMES,
    8: CATEGORY_SCHEDULE_LIBRARY,
    9: CATEGORY_SHARING_API,
    10: CATEGORY_SCHEDULE_LIBRARY,
    11: CATEGORY_SHARING_API,
    12: CATEGORY_SCHEDULE_LIBRARY,
    13: CATEGORY_SCHEDULE_LIBRARY,
    16: CATEGORY_SCHEDULE_LIBRARY,
    17: CATEGORY_MAINTENANCE_REGIMES,
    18: CATEGORY_MAINTENANCE_REGIMES,
    19: CATEGORY_MAINTENANCE_REGIMES,
}

const PREFIX_RULES = [
    [/^authoring(-|$)/, CATEGORY_AUTHORING_CONTENT],
    [
        /^(component|legislation-library|legislationResolutions|maintenance-reference|review-projects|project-bridge|content-translation)/,
        CATEGORY_AUTHORING_CONTENT,
    ],
    [/^(scenario|promote-scenario)(-|$)/, CATEGORY_COST_MODELLER],
    [/^(plan|calendar|week|grid|configureWeekdays|52WeekPlanner|codesOfPractice)/, CATEGORY_PLANNING_COMPLIANCE],
    [
        /^(regime|tailored|advanced-regime-tabs|asset-mapping-(overview|schedule-library-updates|tailored|variation-from-library))/,
        CATEGORY_MAINTENANCE_REGIMES,
    ],
    [/^(download|qrCodes|preferUniqueCodes|ai-schedules|check-list)/, CATEGORY_SCHEDULE_LIBRARY],
    [/^(asset|mobiliser|navigator|edit-assets)/, CATEGORY_ASSETS_MAPPING],
    [/^(sso|identity)/, CATEGORY_IDENTITY_ACCESS],
    [/^(api|Advanced-API|companionTasks)/, CATEGORY_SHARING_API],
    [/^(testing|mock-idp)/, CATEGORY_QA_TESTING],
    [/^(client|sessionmanager|moveSchedules|adoptClient|applicationSwitcher)/, CATEGORY_PLATFORM_ADMIN],
]

export function getCategoryForFeature(feature = {}) {
    const { id, numericalId, category } = feature
    if (category && CATEGORIES.includes(category)) return category
    if (id && FEATURE_CATEGORY[id]) return FEATURE_CATEGORY[id]

    const numericalCategory = getCategoryByNumericalId(numericalId)
    if (numericalCategory) return numericalCategory

    if (id) {
        const rule = PREFIX_RULES.find(([pattern]) => pattern.test(id))
        if (rule) return rule[1]
    }

    return DEFAULT_CATEGORY
}

function getCategoryByNumericalId(numericalId) {
    const value = Number(numericalId)
    const root = Math.trunc(value)
    if (!Number.isFinite(value)) return null
    if (FEATURE_NUMERICAL_ID_CATEGORY[root]) return FEATURE_NUMERICAL_ID_CATEGORY[root]
    if (value >= 400 && value < 500) return CATEGORY_AUTHORING_CONTENT
    if (value >= 2000 && value < 2500) return CATEGORY_PLANNING_COMPLIANCE
    if (value >= 2500 && value < 3000) return CATEGORY_MAINTENANCE_REGIMES
    if (value >= 3000 && value < 4000) return CATEGORY_COST_MODELLER
    if (value >= 5000 && value < 6000) return CATEGORY_AUTHORING_CONTENT
    return NUMERICAL_ROOT[root] || null
}

const FEATURE_NUMERICAL_ID_CATEGORY = {
    200: CATEGORY_PLATFORM_ADMIN,
    202: CATEGORY_PLATFORM_ADMIN,
    300: CATEGORY_IDENTITY_ACCESS,
    301: CATEGORY_IDENTITY_ACCESS,
    400: CATEGORY_PLATFORM_ADMIN,
    1001: CATEGORY_SCHEDULE_LIBRARY,
    1002: CATEGORY_PLATFORM_ADMIN,
    1003: CATEGORY_MAINTENANCE_REGIMES,
    1004: CATEGORY_MAINTENANCE_REGIMES,
    1005: CATEGORY_PLANNING_COMPLIANCE,
}
